import React, { useEffect } from 'react';
import { Row, Col, Form, Button, Dropdown, InputGroup, FormControl, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { targetColor } from '../../Helpers/SearchHelpers';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import IsLoadingBar from '../isLoading';
import Auth from '../../Auth/Auth';
import PinEditor from './PinEditor';
import moment from 'moment';

import NoCommit from '../../images/10607-dog-avatar.png';

import './Pinning.scss';

const auth = new Auth();
let pollingDB;
let lastPollDBDateTime =  moment(new Date()).format("YYYY-MM-DD HH:mm:ss");

export default function Pinning (props) {
    
    const [isLoading, setIsLoading ] = React.useState(true);
    const [sharedCollectionsLoading, setSharedCollectionsLoading] = React.useState(false);
    const [searchActive, setSearchActive ] = React.useState(false);
    const [editMode, setEditMode] = React.useState(false);
    const [addCollectionActive, setAddCollectionActive] = React.useState(false);
    const [showShareCollection, setShowShareCollection] = React.useState(false);
    const [showAddPin, setShowAddPin] = React.useState(false);  
    const [showEditPin, setShowEditPin] = React.useState(false); 
    const [showDeleteModal, setShowDeleteModal] = React.useState(false);    
    const [privateEdits, setPrivateEdits] = React.useState(false);   
    const [showCollectionModal, setShowCollectionModal] = React.useState(false);   
    
    const [dragOver, setDragOver] = React.useState(false);    
    
    const [activeCollection, setActiveCollection] = React.useState(0);
    const [isActiveCollectionLocked, setIsActiveCollectionLocked] = React.useState(0);
    const [isActiveCollectionShared, setIsActiveCollectionShared] = React.useState(0);
    
    
    const [myPins, setMyPins] = React.useState([]);
    const [myCollections, setMyCollections] = React.useState([]);
    const [sharedCollections, setSharedCollections] = React.useState([]);    
    const [sharedPrivateCollections, setSharedPrivateCollections] = React.useState([]);    
    
    const [shareEmails, setShareEmails] = React.useState(""); 
    
    const [myCollectionTargets, setMyCollectionTargets] = React.useState([]);
    const [selectedCollectionPins, setSelectedCollectionPins] = React.useState([]);
    
    const [trending, setTrending] = React.useState([]);
    const [mostPinned, setMostPinned] = React.useState([]);
    const [fetchUsers, setFetchUsers] = React.useState([]);   
    const [emailErrors, setEmailErrors] = React.useState([]);   
    
    const [collectionId, setCollectionId] = React.useState(null);
    const [collectionName, setCollectionName] = React.useState("");
    const [collectionDescription, setCollectionDescription] = React.useState("");     
    const [selectedPins, setSelectedPins]  = React.useState([]);
    const [searchQuery, setSearchQuery] = React.useState(0);
    const [refresh, setRefresh] = React.useState(0);
    const [collectionSearch, setCollectionSearch] = React.useState("collection");    
    const [editCollectionActive, setEditCollectionActive] = React.useState(null);    
    const [selectedEditPin, setSelectedEditPin] = React.useState(null);

    const [pollDB, setPollDB] = React.useState();
    //const [pollCount, setPollCount] = React.useState(0);
    
    let pollCount = 0;

    useEffect(() => { 
        window.addEventListener("visibilitychange", onVisibilityChange, false);
        getCollections();
        getPins(); 
        getTrendingMost();
        
        return () => {
            // Anything in here is fired on component unmount.
            window.removeEventListener("visibilitychange", onVisibilityChange, false);
            killPolling();
        };
    },[]);

    const onVisibilityChange = () => {
        if(document.hidden || document.mozHidden || document.webkitHidden || document.msHidden){
            killPolling();            
        } else {
            killPolling();
            setPollDB(prevState => {                  
                setInterval(() => { 
                    if(pollCount > 100){
                        killPolling();
                    } 
                setActiveCollection( prevState => {
                    checkForPinUpdates(parseInt(prevState));
                    setActiveCollection(prevState);
                });
              }, 1000 * 30);
            });
        }
    };

    const checkForPinUpdates = async (ActiveCollection) => {
        pollCount = pollCount + 1;

        let accessToken = await auth.getToken();
        ActiveCollection = ActiveCollection || 0;

        fetch(`/api/getUpdatedPins`, {
            method : "GET",
            headers: {
                'Authorization': "Bearer " + accessToken,
                "lastPollDateTime" : lastPollDBDateTime
            }
        })
        .then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
                killPolling();
            }
            return  response.json();
        })
        .then(data => {
            lastPollDBDateTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss"); 
            if(data.length > 0){
                setMyPins(data.sort((a,b) => new Date(b.DateCreated) - new Date(a.DateCreated) ));
                let selectedPins = data.filter(el => parseInt(el.CollectionId) === ActiveCollection  && el.CaseId === null);
    
                setSelectedCollectionPins(selectedPins.sort((a,b) => new Date(b.DateCreated) - new Date(a.DateCreated) ));
                setIsLoading(false);
                let dataTargets = new Set();
                for(let i = 0; i < data.length; i++){
                    dataTargets.add(data[i].Target);
                }
                setMyCollectionTargets(Array.from(dataTargets));
            }  
                    
        }).catch((error) => {
            lastPollDBDateTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss"); 
            killPolling();
            window.apiError(error);            
        });
    };

    const getCollections = async () => {
        let accessToken = await auth.getToken();

        fetch(`/api/getUserPinCollections`, {
            method : "GET",
            headers: {
                'Authorization': "Bearer " + accessToken
            }
        })
        .then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        })
        .then(data => {
            data.unshift({Id: 0, CollectionName : "General Collection", isOwn: 1});
            setMyCollections(data);            
        }).catch((error) => {
            window.apiError(error);
        });
    };

    const getSharedCollections = async () => {
        setSharedCollectionsLoading(true);
        let accessToken = await auth.getToken();

        fetch(`/api/getSharedCollections`, {
            method : "GET",
            headers: {
                'Authorization': "Bearer " + accessToken
            }
        })
        .then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        })
        .then(data => {
            setSharedCollections(data);
            setSharedCollectionsLoading(false);
        }).catch((error) => {
            window.apiError(error);
        });

        fetch(`/api/getSharedPrivateCollections`, {
            method : "GET",
            headers: {
                'Authorization': "Bearer " + accessToken
            }
        })
        .then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        })
        .then(data => {
            setSharedPrivateCollections(data);
            setSharedCollectionsLoading(false);
        }).catch((error) => {
            window.apiError(error);
        });
        
    };

    const getPins = async (ActiveCollection) => {        
        let accessToken = await auth.getToken();
        ActiveCollection = ActiveCollection || 0;

        fetch(`/api/getUserPins`, {
            method : "GET",
            headers: {
                'Authorization': "Bearer " + accessToken
            }
        })
        .then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        })
        .then(data => {
            setMyPins(data.sort((a,b) => new Date(b.DateCreated) - new Date(a.DateCreated) ));
            let selectedPins = data.filter(el => parseInt(el.CollectionId) === ActiveCollection && el.CaseId === null);

            setSelectedCollectionPins(selectedPins.sort((a,b) => new Date(b.DateCreated) - new Date(a.DateCreated) ));
            setIsLoading(false);
            let dataTargets = new Set();
            for(let i = 0; i < data.length; i++){
                dataTargets.add(data[i].Target);
            }
            setMyCollectionTargets(Array.from(dataTargets));
        }).catch((error) => {
            window.apiError(error);
        });
    };

    const getTrendingMost = async () => {        
        let accessToken = await auth.getToken();

        fetch(`/api/getTrending`, {
            method : "GET",
            headers: {
                'Authorization': "Bearer " + accessToken
            }
        })
        .then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        })
        .then(data => {
            setTrending(data);
        }).catch((error) => {
            window.apiError(error);
        });

        fetch(`/api/getMostPinned`, {
            method : "GET",
            headers: {
                'Authorization': "Bearer " + accessToken
            }
        })
        .then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        })
        .then(data => {
            setMostPinned(data);
        }).catch((error) => {
            window.apiError(error);
        });
    };

    const countPins = (collectionId) => {
        let numberOfPinsInCollection = myPins.filter(el => parseInt(el.CollectionId) === parseInt(collectionId)  && el.CaseId === null).length;
        return numberOfPinsInCollection;
    };

    const changeActiveCollection = (type,collection) => {
        setCollectionSearch("collection");
        setSelectedPins([]);

        setActiveCollection(collection.Id);
        pollDBForUpdates(collection);
        
        setIsActiveCollectionLocked((collection.isSharedCollection && !collection.isEditable) || 0);
        setIsActiveCollectionShared(collection.isSharedCollection);
        if(type === "collection"){            
            let selectedPins = myPins.filter(el => parseInt(el.CollectionId) === parseInt(collection.Id) && el.CaseId === null);
            setSelectedCollectionPins(selectedPins.sort((a,b) => new Date(b.DateCreated) -  new Date(a.DateCreated) ));
            return;
        }
        let selectedPins = myPins.filter(el => el.Target === collection);
        setSelectedCollectionPins(selectedPins.sort((a,b) => new Date(b.DateCreated) -  new Date(a.DateCreated) ));

        
        return;
    };

    const pollDBForUpdates = (collection) => {
        if(!collection.isOwn){            
            setPollDB(setInterval( async () => {
                if(pollCount > 100){
                    killPolling();
                    return;
                } 
                await killPolling();
                checkForPinUpdates(parseInt(collection.Id));
              }, 1000 * 30));
        } else {
            killPolling();
        }
    };

    const killPolling = () => {
        var killId = setTimeout(function() {
            for (var i = killId; i > 0; i--) {
                clearInterval(i);
            }
          }, 3000);
        clearInterval(pollDB);
        pollCount = 0; 
    };

    const allowDrop = (e) => {
        e.preventDefault();
    };

    const drag = (e) => {
        if(selectedPins.length > 1){     
            let dragImage = document.createElement("div");
            dragImage.innerHTML = `<h6 class="drag">Multiple Bookmarks - <span class="drag-pill">${selectedPins.length}<span><h6>`;
            e.dataTransfer.setData("pins", JSON.stringify(selectedPins));
            document.body.appendChild(dragImage);
            setTimeout(function() { dragImage.parentNode.removeChild(dragImage); });
            e.dataTransfer.setDragImage(dragImage, 50, 0);
        } else {
            e.dataTransfer.setData("text", e.target.id);
        }        
    };

    const drop = (e) => {
        e.preventDefault();
        setDragOver(null);
        var pinId = e.dataTransfer.getData("text") !== "" ? `[${e.dataTransfer.getData("text")}]` : e.dataTransfer.getData("pins");
        let pins = JSON.parse(pinId);
        let dropArea = e.target.closest(".drop-area");
        let dropAreaId = dropArea.id;

        if(isActiveCollectionShared !== 1){
            updatePinCollection();
        } else {
            copyPinToCollection();
        }

        async function updatePinCollection(){
            let accessToken = await auth.getToken();

            let pinData = {
                PinIds : JSON.parse(pinId),
                NewCollectionId : parseInt(dropAreaId)
            };

            fetch(`/api/updatePinCollection`, {
                method : "POST",
                headers: {
                    'Content-Type' : 'application/json',
                    'Authorization': "Bearer " + accessToken                    
                },
                body : JSON.stringify(pinData)
            })
            .then(response => {
                if(response.status !== 200)
                {   
                    let payload = [{
                        status : response.status,
                        rawmsg : response.statusText,
                        cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                        location: response.url,
                        timestamp : Date.now(),
                    }];
                    throw {
                        payload: payload,
                        error: new Error()
                    };
                }
                return  response.json();
            })
            .then(data => {
                let selectedCollectionPinArr = selectedCollectionPins;
                pins.map(item => {
                    selectedCollectionPinArr = selectedCollectionPinArr.filter(el => el.Id !== item);            
                });
                setSelectedCollectionPins(selectedCollectionPinArr);

                for(let i = 0; i < pins.length; i++){
                    let obj = myPins.findIndex(el => el.Id === pins[i]);
                    myPins[obj].CollectionId = parseInt(dropAreaId);
        
                    setMyPins(myPins);
                }                
                toast.info("Pin Moved", {
                    position: "bottom-left",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true
                });

                setSelectedPins([]);
            }).catch((error) => {
                window.apiError(error);
            });
        }

        async function copyPinToCollection(collection){
            let accessToken = await auth.getToken();

            let pinData = {
                PinIds : JSON.parse(pinId),
                NewCollectionId : parseInt(dropAreaId)
            }

            if(collection){
                pinData = {
                    PinIds : JSON.parse(selectedEditPin),
                    NewCollectionId : parseInt(collection)
                };
            }

            fetch(`/api/copyPinsToCollection`, {
                method : "POST",
                headers: {
                    'Content-Type' : 'application/json',
                    'Authorization': "Bearer " + accessToken                    
                },
                body : JSON.stringify(pinData)
            })
            .then(response => {
                if(response.status !== 200)
                {   
                    let payload = [{
                        status : response.status,
                        rawmsg : response.statusText,
                        cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                        location: response.url,
                        timestamp : Date.now(),
                    }];
                    throw {
                        payload: payload,
                        error: new Error()
                    };
                }
                return  response.json();
            })
            .then(data => {         
                setMyPins([...myPins, data]); 

                toast.info("Pin Copied", {
                    position: "bottom-left",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true
                });

                setSelectedPins([]);
            }).catch((error) => {
                window.apiError(error);
            });
        }
        
    };

    const copyPinToCollection = async (collection) => {
        let accessToken = await auth.getToken();

        let pinData = {
            PinIds : [JSON.parse(selectedEditPin)],
            NewCollectionId : parseInt(collection)
        };

        fetch(`/api/copyPinsToCollection`, {
            method : "POST",
            headers: {
                'Content-Type' : 'application/json',
                'Authorization': "Bearer " + accessToken                    
            },
            body : JSON.stringify(pinData)
        })
        .then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                };
            }
            return  response.json();
        })
        .then(data => {         
            setMyPins([data, ...myPins]); 

            toast.info("Pin Copied", {
                position: "bottom-left",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true
            });
            setShowCollectionModal(false);
            setSelectedEditPin(null);
            setSelectedPins([]);
        }).catch((error) => {
            window.apiError(error);
        });
    };

    const AddCollection = async () => {
        let accessToken = await auth.getToken();
        let newCollection = {
            CollectionName : collectionName,
            CollectionDescription: collectionDescription
        };

        fetch(`/api/addNewCollection`, {
            method : "POST",
            headers: {
                'Content-Type' : 'application/json',
                'Authorization': "Bearer " + accessToken
            },
            body : JSON.stringify(newCollection)
        })
        .then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        })
        .then(data => {
            data.isOwn = 1;
            setMyCollections([...myCollections, data]);
            setAddCollectionActive(false);
            setCollectionName("");
            setCollectionDescription("");
        }).catch((error) => {
            window.apiError(error);
        });
    };

    const UpdateCollection = async () => {
        let accessToken = await auth.getToken();
        let editedCollection = {
            Id: collectionId,
            CollectionName : collectionName,
            CollectionDescription: collectionDescription
        };

        fetch(`/api/editCollection`, {
            method : "POST",
            headers: {
                'Content-Type' : 'application/json',
                'Authorization': "Bearer " + accessToken
            },
            body : JSON.stringify(editedCollection)
        })
        .then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        })
        .then(data => {
            let obj = myCollections.findIndex(el => el.Id === collectionId);
            let collectionArr = myCollections;
            collectionArr[obj].CollectionName = collectionName;
            collectionArr[obj].CollectionDescription = collectionDescription;
            toast("Changed Collection Name", {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true
              });
            setMyCollections(collectionArr);
            setEditCollectionActive(false);
            setCollectionName("");
            setCollectionDescription("");
        }).catch((error) => {
            window.apiError(error);
        });
    };

    const selectPin = (pinId) => {
        if(selectedPins.includes(pinId)){
            let updatedSelectedPinArr = selectedPins.filter(el => el !== pinId);
            setSelectedPins(updatedSelectedPinArr);
            return;
        }

        setSelectedPins([...selectedPins, pinId]);
    };

    const removePins = async () => {
        let accessToken = await auth.getToken();

        let PinsToDelete = {
            PinIds : selectedPins.join(",")
        };

        fetch(`/api/removePins`, {
            method : "POST",
            headers: {
                'Content-Type' : 'application/json',
                'Authorization': "Bearer " + accessToken
            },
            body : JSON.stringify(PinsToDelete)
        })
        .then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        })
        .then(data => {
            let selectedCollectionPinArr = selectedCollectionPins;
            selectedPins.map(item => {
                selectedCollectionPinArr = selectedCollectionPinArr.filter(el => el.Id !== item);     
            });
            setSelectedCollectionPins(selectedCollectionPinArr);

            let MyPinArr = myPins;
            selectedPins.map(item => {
                MyPinArr = MyPinArr.filter(el => el.Id !== item);
            });
            setMyPins(MyPinArr);
            setSelectedPins([]);

        }).catch((error) => {
            window.apiError(error);
        });
    };

    const selectAll = () => {
        if(selectedPins.length === 1){
            let selectAllPins = []
            selectedCollectionPins.map(el => {
                selectAllPins.push(el.Id);                         
            });
            setSelectedPins(selectAllPins);       
            return;
        }
        setSelectedPins([]);
    };

    const changeSort = (sort) => {
        let sortedArr = []
        switch(sort){
            case "AZDesc" : sortedArr = selectedCollectionPins.sort((a,b) => b.Title.localeCompare(a.Title));
            break;

            case "AZAsc" : sortedArr = selectedCollectionPins.sort((a,b) => a.Title.localeCompare(b.Title));
            break;

            case "DateDesc" : sortedArr = selectedCollectionPins.sort((a,b) => new Date(b.DateCreated) - new Date(a.DateCreated) );
            break;

            case "DateAsc" : sortedArr = selectedCollectionPins.sort((a,b) => new Date(a.DateCreated) - new Date(b.DateCreated) );
            break;

            default : sortedArr = selectedCollectionPins;
        }

        setSelectedCollectionPins(sortedArr);
        setRefresh(Math.floor(Math.random() * 10000));
        
    };

    const search = (e, searchAgain, collection) => {
        e.preventDefault();
        const inputValue = searchAgain ? searchQuery : e.target.value.trim().toLowerCase();
        const inputLength = inputValue.length;
        setSearchQuery(inputValue);
        let pinArr;
        if(collection){
            pinArr = collection === "collection" ? myPins.filter(el => (parseInt(el.CollectionId) === parseInt(activeCollection)) && el.CaseId === null) : myPins;
        } else {
            pinArr = collectionSearch === "collection" ? myPins.filter(el => (parseInt(el.CollectionId) === parseInt(activeCollection)) && el.CaseId === null) : myPins;
        }
        
        setSelectedCollectionPins(pinArr.filter(el => 
            el.Title && el.Title.trim().toLowerCase().indexOf(inputValue) > -1 || el.Description && el.Description.trim().toLowerCase().indexOf(inputValue) > -1
        ));
    };

    const removeCollection = (collectionId) => {

        let options = {};
        options["Remove Pins"] = "Remove Pins";
        myCollections.map((item) => {
            if(item.Id !== collectionId){
                options[item.Id] = item.CollectionName;
            }
        });

        Swal.fire({
            title: 'Move pins from this collection to:',
            input: 'select',
            inputOptions: options,
            inputPlaceholder: 'Select collection',
            showCancelButton: true,
            inputValidator: (value) => {
              return new Promise( async (resolve) => {
                if (value !== '') {                    
                    Swal.showLoading();
                    let x = await deleteCollection(collectionId, value);
                    resolve();
                } else {
                  resolve('You need to select a collection :)');
                }
              });
            }
          });
    
          async function deleteCollection(collectionId, moveTo){
            let accessToken = await auth.getToken();

            let collectionDetails = {
                CollectionId : collectionId,
                moveTo: moveTo
            };
    
            fetch(`/api/removeCollection`, {
                method : "POST",
                headers: {
                    'Content-Type' : 'application/json',
                    'Authorization': "Bearer " + accessToken
                },
                body : JSON.stringify(collectionDetails)
            })
            .then(response => {
                if(response.status !== 200)
                {   
                    let payload = [{
                        status : response.status,
                        rawmsg : response.statusText,
                        cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                        location: response.url,
                        timestamp : Date.now(),
                    }];
                    throw {
                        payload: payload,
                        error: new Error()
                      };
                }
                return  response.json();
            })
            .then(data => {
                let collectionArr = myCollections.filter(el => parseInt(el.Id) !== parseInt(collectionId));

                setMyCollections(collectionArr);
                setEditMode(false);
                getPins();
                changeActiveCollection(0);
                return true;
            }).catch((error) => {
                window.apiError(error);
            });
          }
    };

    const removeSharedCollection = async (collectionId) => {
        let accessToken = await auth.getToken();

        fetch(`/api/removeSharedCollection`, {
            method : "POST",
            headers: {
                'Content-Type' : 'application/json',
                'Authorization': "Bearer " + accessToken,
                collectionid : collectionId
            }
        })
        .then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        })
        .then(data => {
                       
            let collectionArr = myCollections.filter(el => el.Id !== collectionId);
            setMyCollections(collectionArr);
            setRefresh(Math.random() * 100000);
            changeActiveCollection(0); 
        }).catch((error) => {
            window.apiError(error);
        });
    };

    const editCollection = (e, collection) => {
        e.preventDefault();
        setEditCollectionActive(true);
        setCollectionId(collection.Id);
        setCollectionDescription(collection.CollectionDescription);
        setCollectionName(collection.CollectionName);
    };

    const makeCollectionPublic = async () => {
        let accessToken = await auth.getToken();

        let shareData = {
            Id : activeCollection,
            isEditable : 0
        };    

        fetch(`/api/shareCollection`, {
            method : "POST",
            headers: {
                'Content-Type' : 'application/json',
                'Authorization': "Bearer " + accessToken
            },
            body : JSON.stringify(shareData)
        })
        .then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        })
        .then(data => {            
            let collections = myCollections;
            let obj = collections.findIndex(el => el.Id === activeCollection);
            collections[obj].isPublic = 1;
            setMyCollections(collections);
            setRefresh(Math.random() * 10000);
            setShowShareCollection(false);
            Swal.fire(`Your collection has been shared :)`);
        }).catch((error) => {
            window.apiError(error);
        });
    };

    const makeCollectionPrivate = async () => {
        let accessToken = await auth.getToken();

        let shareData = {
            Id : activeCollection,
            isEditable : 0
        };



        fetch(`/api/unshareCollection`, {
            method : "POST",
            headers: {
                'Content-Type' : 'application/json',
                'Authorization': "Bearer " + accessToken
            },
            body : JSON.stringify(shareData)
        })
        .then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        })
        .then(data => {           
            let collections = myCollections
            let obj = collections.findIndex(el => el.Id === activeCollection);
            collections[obj].isPublic = 0;
            setMyCollections(collections);
            setShowShareCollection(false);
            setRefresh(Math.random() * 10000);
            Swal.fire(`Your collection has been un-shared :)`);
        }).catch((error) => {
            window.apiError(error);
        });
    };

    const shareCollectionWithUsers = async () => {
        let emailGuids = [];
        let emailErrors = [];
        let emails = shareEmails.split(";");
        //garry.cummins@ceridian.com; rex@ceridian.com
        emails.map(function(item) {
            for(let i = 0; i < fetchUsers.length; i++){
                if(fetchUsers[i].username.toLowerCase() === item.trim().toLowerCase()){
                    emailGuids.push(fetchUsers[i].userguid);
                    return;
                }                
            }
            emailErrors.push(item);
        });
        setEmailErrors(emailErrors);

        if(emailErrors.length > 0){
            return;
        }
        
        let accessToken = await auth.getToken();

        let shareData = {
            Id : activeCollection,
            isEditable : privateEdits ? 1 : 0,
            shareEmails: emailGuids.join(",")
        };

        fetch(`/api/shareCollectionWithUsers`, {
            method : "POST",
            headers: {
                'Content-Type' : 'application/json',
                'Authorization': "Bearer " + accessToken
            },
            body : JSON.stringify(shareData)
        })
        .then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        })
        .then(data => {
            Swal.fire(`Your collection has been shared :)`);
            setShowShareCollection(false);
            setShareEmails("");
        }).catch((error) => {
            window.apiError(error);
        });
    };

    const addSharedCollectionToMyCollections = async (sharedCollection) => {

        let accessToken = await auth.getToken();

        let collectionData = {
            CollectionId : sharedCollection.Id,
            CollectionOwnerGuid: sharedCollection.UserGUID
        };

        sharedCollection.isSharedCollection = 1;

        fetch(`/api/addSharedCollection`, {
            method : "POST",
            headers: {
                'Content-Type' : 'application/json',
                'Authorization': "Bearer " + accessToken
            },
            body : JSON.stringify(collectionData)
        })
        .then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        })
        .then(data => {
            let exists = false;
            for(let i = 0; i < myCollections.length; i++){
                if(myCollections[i].Id === sharedCollection.Id){
                    exists = true;
                }
            }

            if(!exists){
                setMyCollections([...myCollections, sharedCollection]);
            }

            setAddCollectionActive(false);
            setCollectionId(null)
            setCollectionName("");
            setCollectionDescription("");
            getPins();
        }).catch((error) => {
            window.apiError(error);
        });
    };

    const getCollectionName = (activeCollection) => {
        let collection = myCollections.filter(el => parseInt(el.Id) === parseInt(activeCollection));
        if(collection.length > 0){
            return collection[0].CollectionName;
        }        
    };

    const checkIsPublic = (activeCollection) => {
        return myCollections.filter(el => parseInt(el.Id) === parseInt(activeCollection))[0].isPublic;
    };

    const getFetchUsers = async () => {
        if(fetchUsers.length === 0){
            let accessToken = await auth.getToken();

            fetch(`/api/getFetchUsers`, {
                method : "GET",
                headers: {
                    'Authorization': "Bearer " + accessToken
                }
            })
            .then(response => {
                if(response.status !== 200)
                {   
                    let payload = [{
                        status : response.status,
                        rawmsg : response.statusText,
                        cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                        location: response.url,
                        timestamp : Date.now(),
                    }];
                    throw {
                        payload: payload,
                        error: new Error()
                      };
                }
                return  response.json();
            })
            .then(data => {
                setFetchUsers(data);
            }).catch((error) => {
                window.apiError(error);
            });    
        }
    };

    const updatePin = (pinData) => {
        if(pinData){
            let userPins = myPins;
            let obj = userPins.findIndex(el => el.Id === pinData.Id);
            userPins[obj].Title = pinData.Title;
            userPins[obj].Description = pinData.Description;
            userPins[obj].CollectionId = pinData.CollectionId;
            userPins[obj].Link = pinData.Link;
            setMyPins(userPins);

            let selectedPins = userPins.filter(el => parseInt(el.CollectionId) === parseInt(activeCollection));
            setSelectedCollectionPins(selectedPins.sort((a,b) => new Date(b.DateCreated) -  new Date(a.DateCreated) ));
            setRefresh(Math.random() * 10000);
        }
    };

    if(isLoading) {
        return (
            <div>
                <IsLoadingBar  alttext={"Grabbing your pins"} customWording={"Grabbing your pins"}   />
            </div>
        );
    }
    
    return (
        <Row id="pinning">
            <Col lg={{ span : 2 }} className="search-left">
                <div className="collections">
                    <Button variant="primary" className="w-100 new-collection-btn" onClick={() => { getSharedCollections(); setAddCollectionActive(!addCollectionActive);} } ><span><i className="fas fa-folder-plus"></i>New Collection</span></Button>
                    {editCollectionActive && (
                        <div className="collection_add">
                            <Form>
                                <label>Collection Name</label>
                                <Form.Control type="text" value={collectionName} onChange={(e) => setCollectionName(e.target.value)} />
                                <label>Collection Description</label>
                                <Form.Control as="textarea" type="text" value={collectionDescription} onChange={(e) => setCollectionDescription(e.target.value)} />
                                <Button variant="link" className="cancel_btn" onClick={() => { setCollectionName(""); setCollectionDescription(""); setCollectionId(null); setAddCollectionActive(false); setEditCollectionActive(false); } }>Cancel</Button>
                                {addCollectionActive && (
                                    <Button variant="link" className="add_btn" onClick={() => AddCollection()}>Add</Button>
                                )}

                                {editCollectionActive && (
                                    <Button variant="link" className="add_btn" onClick={() => UpdateCollection()}>Save</Button>
                                )}                                
                            </Form>
                        </div>
                    )}

                    <p className="header p-0 mb-2">                        
                        My Collections 
                        <Button variant="link" className="p-0 m-0 float-right" onClick={() => setEditMode(!editMode)} ><i className="fas fa-pen"></i></Button>
                    </p>                   

                    {myCollections.map((item, index) =>
                        <div key={index} className={dragOver === item.Id ? "drop-area drag-over p" : "drop-area p"} 
                        style={activeCollection === item.Id ? {backgroundColor: "#f5f5f5", borderLeft: "solid 5px #689df6", fontWeight : 600} : {} } 
                        id={item.Id} 
                        onClick={() => changeActiveCollection("collection", item)} 
                        onDrop={(e) => drop(e)} 
                        onDragOver={(e) => {
                            if((item.isShared && item.isEditable) || item.isOwn){
                                allowDrop(e); 
                                setDragOver(item.Id);
                            }
                        }}
                        onDragLeave={(e) => setDragOver(null)} 
                        >
                            <div className="collection-info-wrapper">
                            {item.isSharedCollection ?
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip className="white-tool">
                                       {(item.isShared && item.isEditable) ?
                                            <p>
                                                Owned By : <b>{item.OwnedBy}</b>
                                                <br />
                                                Is Editable.                                            
                                            </p>
                                       :
                                            <p>
                                                Owned By : <b>{item.OwnedBy}</b>
                                                <br />
                                                Not Editable.                                            
                                            </p>
                                        }
                                    </Tooltip>
                                }
                                >
                                <i className={(item.isShared && item.isEditable) ? "fas fa-unlock" : "fas fa-lock"}></i>
                            </OverlayTrigger>
                                
                            :
                                <i className={activeCollection === item.Id ? "far fa-folder-open" : "far fa-folder"}></i>
                            }
                            
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip className="white-tool">
                                            <p>
                                                {item.CollectionName}
                                                <br />
                                                {item.CollectionDescription}                                   
                                            </p>
                                    </Tooltip>
                                }
                                >
                                <span>{item.CollectionName}</span>
                            </OverlayTrigger>
                            </div>
                            
                            {(editMode && parseInt(item.Id) !== 0) ? 
                            <div className="collection-options">
                                {item.isSharedCollection ?
                                    <Button variant="link" className="float-right pl-0 py-0" onClick={(e) => removeSharedCollection(item.Id) }><i className="fas fa-times"></i></Button>   
                                :
                                    <>
                                    <Button variant="link" className="float-right pl-0 py-0" onClick={(e) => removeCollection(item.Id) }><i className="far fa-trash-alt"></i></Button>   
                                    <Button variant="link" className="float-right pl-0 py-0" onClick={(e) => editCollection(e,item) }><i className="fas fa-pen"></i></Button> 
                                    </>
                                }                                
                            </div>
                            :
                            <span className="collection_count">{countPins(item.Id)}</span>
                            }
                            
                        </div>
                    )}

                    <p className="header p-0 mb-2 mt-5">
                        Collection Targets
                    </p>
                    {myCollectionTargets.map((item, index) =>
                        <p key={index} className="drop-area pl-0" style={activeCollection === item ? {backgroundColor: "#f5f5f5", borderLeft: "solid 5px #689df6"} : {} } id={item} onClick={() => changeActiveCollection("target", item)} >
                            <span style={{ color : targetColor(item), fontWeight: 600}}>#{item}</span>                          
                        </p>
                    )}

                </div>
            </Col>
            <Col lg={{span: 8}} className="search-left">
                <div className="my-pin-container">
                    <p className="header">
                        Your Pins
                    </p>
                    <div className="pin_search_container active mt-0 ml-2">
                        <Form onSubmit={(e) => search(e, true)}>
                            <InputGroup>
                                <FormControl
                                type="text"
                                onChange={(e) => search(e) }
                                />
                                <InputGroup.Append>
                                <Button variant="link"  type="submit">
                                    <svg width="30px" height="30px" fill="grey"><path d="M22.5,17.8a17.969,17.969,0,0,0-2-1.9A16.379,16.379,0,0,0,18,13.8a15.371,15.371,0,0,1-1.9-1.7,8.46,8.46,0,0,0,.6-4.9A8.116,8.116,0,0,0,11,.3a9.777,9.777,0,0,0-6.9.8A7.1,7.1,0,0,0,1.2,3.9,12.338,12.338,0,0,0,0,7.6v.5H0v.4a12.216,12.216,0,0,0,.3,2.6,7.606,7.606,0,0,0,2.5,3.6A9.825,9.825,0,0,0,12.7,16a7.165,7.165,0,0,0,1.5-1.1,7.678,7.678,0,0,1,1.6,1.5,12.667,12.667,0,0,0,1.3,1.1c.2.2.4.3.6.5a11.408,11.408,0,0,1,1.1,1.1,5.845,5.845,0,0,0,1.4,1.3l.4.3.3-.4a14.622,14.622,0,0,1,1.6-1.9l.3-.3Zm-8.873-7.263c-.107.214-.107.32-.214.534-.427.854-.748,1.709-1.5,2.029h0a6.012,6.012,0,0,1-5.233.534H6.579A3.6,3.6,0,0,1,3.909,11.5c-.32-.534-.641-1.175-.854-1.6,0-.534-.107-.961-.107-1.388V7.76c.107-.427.32-.854.427-1.282V6.265A9.354,9.354,0,0,1,5.4,3.7a4.9,4.9,0,0,1,3.631-.854c3.1.32,4.165,1.282,4.806,4.272A5.332,5.332,0,0,1,13.627,10.537Z" transform="translate(0 0.004)"></path></svg>
                                </Button>
                                </InputGroup.Append>
                            </InputGroup>
                            <p className="m-0"><span className={collectionSearch === "collection" ? "active" : ""} onClick={(e) => { setCollectionSearch("collection"); search(e, true,"collection")} }>This Collection</span> | <span  className={collectionSearch !== "collection" ? "active" : ""} onClick={(e) => { setCollectionSearch("all"); search(e, true, "all") } }>All Collections</span></p> 
                        </Form>                    
                    </div>  

                    {(selectedCollectionPins.length === 0 && parseInt(activeCollection) !== 1) && (
                        <div className="waiting-for-search w-100" style={{ backgroundImage : `url(${NoCommit})` }}>
                            <h4>No Pins</h4>
                            <br />
                            <h5 style={{color : "#404040"}}>
                                <small>Trying adding some by using the <i className="fas fa-thumbtack"></i>  icon on the results page</small>
                            </h5>                        
                        </div>
                    )}

                    {(selectedCollectionPins.length === 0 && parseInt(activeCollection) === 1) && (
                        <div className="waiting-for-search w-100" style={{ backgroundImage : `url(${NoCommit})` }}>
                            <h4>This Collection was deleted by the owner</h4>
                            <br />
                            <h5 style={{color : "#404040"}}>
                                <small>You can remove it from your collections on the left by using the <b>X</b> icon.</small>
                            </h5>                        
                        </div>
                    )}

                    <div className="multi_select_options">
                        {selectedPins.length === 0 && ( 
                            <Button className="add-custom-pin-btn" onClick={() => setShowAddPin(true)}>Add Custom Pin</Button>
                        )}

                        {selectedPins.length > 0 && (       
                            <>             
                                <OverlayTrigger
                                    placement="top"
                                    overlay={
                                        <Tooltip>
                                            <span>Multi-Select</span>
                                        </Tooltip>
                                    }
                                >
                                    <Button variant="link" onClick={() => selectAll()}><i className="far fa-check-circle"></i></Button>
                                </OverlayTrigger> 
                               
                                {isActiveCollectionLocked === 0 && (
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip>
                                                <span>Remove Selected</span>
                                            </Tooltip>
                                        }
                                    >
                                        <Button variant="link" onClick={() => { selectedPins.length > 1 ? setShowDeleteModal(true) : removePins() } }><i className="far fa-trash-alt"></i></Button> 
                                    </OverlayTrigger> 
                                   
                                )}
                                    
                            </>               
                        )}
                        {(activeCollection !== 0 && isActiveCollectionLocked === 0) && (
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip>
                                        <span>Share Collection</span>
                                    </Tooltip>
                                }
                            >
                                <Button variant="link" onClick={() => { getFetchUsers();  setShowShareCollection(true) }}><i className="fas fa-share-alt"></i></Button>  
                            </OverlayTrigger>                             
                        )}
                        
                        <Dropdown className="d-inline-block">
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip>
                                        <span>Sort Pins</span>
                                    </Tooltip>
                                }
                            >
                                <Dropdown.Toggle variant="link" id="dropdown-basic">
                                    <i className="fas fa-sort"></i>
                                </Dropdown.Toggle>
                            </OverlayTrigger>  
                            

                            <Dropdown.Menu alignRight>
                                <Dropdown.Item onClick={() => changeSort("AZAsc")}>Sort A to Z</Dropdown.Item>
                                <Dropdown.Item onClick={() => changeSort("AZDesc")}>Sort Z to A</Dropdown.Item>                                
                                <Dropdown.Item onClick={() => changeSort("DateDesc")}>Sort by Newest</Dropdown.Item>
                                <Dropdown.Item onClick={() => changeSort("DateAsc")}>Sort by Oldest</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                    <div className="result-container">
                        {selectedCollectionPins.map((item, index) =>
                            <div key={index} id={item.Id} className="result-item" draggable={true} onDragStart={(e) => drag(e)} > 
                            
                                <div className={selectedPins.length > 0 ? "pin_options active" : "pin_options" }>
                                    <>
                                    {isActiveCollectionLocked === 0 && (
                                        <>
                                        <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip>
                                                <span>Copy Pin to Collection</span>
                                            </Tooltip>
                                        }
                                        >
                                            <Button variant="link" className="p-0 pr-3" onClick={() => { setSelectedEditPin(item.Id); setShowCollectionModal(true) } }><i className="far fa-copy"></i></Button>
                                        </OverlayTrigger>  

                                        <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip>
                                                <span>Edit Pin</span>
                                            </Tooltip>
                                        }
                                        >
                                            <Button variant="link" className="p-0" onClick={() => { setShowEditPin(true); setSelectedEditPin(item); }}><i className="fas fa-pen"></i></Button>
                                        </OverlayTrigger>  
                                        </>
                                    )}        
                                    <OverlayTrigger
                                        placement="top" 
                                        overlay={
                                            <Tooltip>
                                                <span>Select/Unselect Multiple</span>
                                            </Tooltip>
                                        }
                                        >
                                            <Button variant="link" onClick={() => selectPin(item.Id)}><i className={selectedPins.includes(item.Id) ? "fas fa-check-circle" : "far fa-circle"} ></i></Button>
                                        </OverlayTrigger>                        
                                
                                    </>
                                </div>
                                    
                                <div className="search-title-wrapper">
                                    <a href={item.Link} onClick={(e) => {e.preventDefault(); props.resultClick(e,item.Link, item.Title) } }>
                                        <h5 className="search-title">{item.Title}</h5>
                                    </a>
                                    {item.Target === "Custom" && (
                                        <p className="link m-0">
                                            <a href={item.Link} target="_blank" ><small>{item.Link}</small></a>
                                        </p>
                                        
                                    )}
                                </div>  

                                <div className="sub-titles">
                                    <span className="search-target">
                                    {item.Target} 
                                    </span> 
                                    {collectionSearch === 'all' && (
                                        <>
                                            <br />
                                            {item.CaseId ?
                                            <span>Case Pin</span>
                                            :
                                            <span><Button variant="link" className="p-0" onClick={() => { setCollectionSearch("collection"); setActiveCollection(item.CollectionId) } }>{getCollectionName(item.CollectionId)}</Button></span>
                                            }
                                        </>
                                    )}
                                </div>
                            
                                <p className="result-body">
                                    {item.Description}
                                </p>

                                {item.CaseId && (
                                    <p className="m-0"><small className="font-weight-bold">Pinned to Case: {item.CaseId}</small></p>
                                )}

                                <footer>
                                    <p className="m-0"><small>Date Pinned : {moment(item.DateCreated).format('ll')}</small></p>
                                </footer>
                                
                            </div>
                        )}
                    </div>    
                    
                
                </div>               
            </Col>
            <Col lg={{span: 2}} className="search-left">
                <div className="trending">
                    <p className="header">Trending Pins</p>
                    {trending.map((item,index) => 
                     <OverlayTrigger
                     placement="top"
                     key={index} 
                     overlay={
                         <Tooltip className="white-tool">
                             <span>{item.Title}</span>
                         </Tooltip>
                     }
                     >
                        <div key={index} className="w-100 trend">
                            <Button variant="link" onClick={(e) => {e.preventDefault(); props.resultClick(e,item.Link, item.Title) } }><p className="title">{item.Title}</p><p className="pill">{item.PinCount}</p></Button>
                            <Button variant="link" onClick={() => { setSelectedEditPin(item.TrendId); setShowCollectionModal(true) }}><i className="fas fa-thumbtack"></i></Button>
                        </div>                       
                    </OverlayTrigger>
                    )}
                    <p className="header mt-5">Most Pinned</p>   
                    {mostPinned.map((item,index) => 
                    <OverlayTrigger
                    placement="top"
                    key={index} 
                    overlay={
                        <Tooltip className="white-tool">
                            <span>{item.Title}</span>
                        </Tooltip>
                    }
                    >
                        <div key={index} className="w-100 trend">
                            <Button variant="link" onClick={(e) => {e.preventDefault(); props.resultClick(e,item.Link, item.Title) } }><p className="title">{item.Title}</p><p className="pill">{item.PinCount}</p></Button>
                            <Button variant="link" onClick={() => { setSelectedEditPin(item.MostPinnedId); setShowCollectionModal(true) }}><i className="fas fa-thumbtack"></i></Button>
                        </div>
                   </OverlayTrigger>
                    )}
                </div>             
            </Col>

            <Modal show={addCollectionActive} onHide={() => setAddCollectionActive(false)} dialogClassName="add-collection-modal" animation={false} centered>
                <div className="collection_add">
                    <h6>Manually Add Collection</h6>
                    <Form>
                        <label>Collection Name</label>
                        <Form.Control type="text" value={collectionName} onChange={(e) => setCollectionName(e.target.value)} />
                        <label>Collection Description</label>
                        <Form.Control as="textarea" type="text" value={collectionDescription} onChange={(e) => setCollectionDescription(e.target.value)} />
                        <Button variant="link" className="cancel_btn" onClick={() => { setCollectionName(""); setCollectionDescription(""); setCollectionId(null); setAddCollectionActive(false); setEditCollectionActive(false); } }>Cancel</Button>
                        {addCollectionActive && (
                            <Button variant="link" className="add_btn" onClick={() => AddCollection()}>Add</Button>
                        )}

                        {editCollectionActive && (
                            <Button variant="link" className="add_btn" onClick={() => UpdateCollection()}>Save</Button>
                        )}                                
                    </Form>
                    <hr />
                    <h6>Public Collections</h6>
                    <div>
                        <label>Top Collections</label>
                        <div className="shared-collection-container">
                            {sharedCollectionsLoading ? 
                                <div style={{ width: 400}}>
                                    <IsLoadingBar />
                                </div>
                                :
                                <>
                                {sharedCollections.map((item, index) => 
                                    <OverlayTrigger
                                    placement="top"
                                    key={index}
                                    overlay={
                                        <Tooltip className="white-tool">
                                                <p>
                                                {item.CollectionName}                                            
                                                </p>
                                        </Tooltip>
                                    }
                                    >
                                        <div className="shared-collection-item" onClick={() => addSharedCollectionToMyCollections(item)}>
                                            <i className="far fa-folder"></i>
                                            <p>{item.CollectionName}</p>
                                        </div>
                                    </OverlayTrigger>                                   
                                )}
                                </>
                            }                            
                        </div>
                    </div>
                    <h6>Shared With You</h6>
                    <div>
                        <div className="shared-collection-container">
                            {sharedCollectionsLoading ? 
                                <div style={{ width: 400}}>
                                    <IsLoadingBar />
                                </div>
                                :
                                <>
                                {sharedPrivateCollections.map((item, index) => 
                                    <OverlayTrigger
                                    placement="top"
                                    key={index}
                                    overlay={
                                        <Tooltip className="white-tool">
                                                <p>
                                                {item.CollectionName}                                            
                                                </p>
                                        </Tooltip>
                                    }
                                    >
                                        <div className="shared-collection-item" onClick={() => addSharedCollectionToMyCollections(item)}>
                                            <i className="far fa-folder"></i>
                                            <p>{item.CollectionName}</p>
                                        </div>
                                    </OverlayTrigger>

                                )}
                                </>
                            }                            
                        </div>
                    </div>
                </div>
            </Modal>
       
            <Modal show={showShareCollection} onHide={() => setShowShareCollection(false)} dialogClassName="share-modal" animation={false} centered>
                {showShareCollection && (
                    <div className="share_collection">
                        <h6>Make Collection {getCollectionName(activeCollection)} {checkIsPublic(activeCollection) ? "Private" : "Public"}</h6>
                        <div className="w-100 text-right">
                            <Button onClick={() => checkIsPublic(activeCollection) ? makeCollectionPrivate() : makeCollectionPublic() }>Make {checkIsPublic(activeCollection) ? "Private" : "Public"}</Button>
                        </div>
                        
                        <hr />
                        <h6>Share Collection {getCollectionName(activeCollection)} with users:</h6>
                        <textarea className="form-control" placeholder="seperate emails with semicolon;" value={shareEmails} onChange={(e) => setShareEmails(e.target.value)}></textarea>
                        {emailErrors.map((item,index) => 
                        <p key={index} className="error-msg">{item} was not found in Fetch. Make sure the email is correct and the user has logged into Fetch.</p>
                        )}
                        <Form.Check 
                            custom
                            type={'checkbox'}
                            id={`private-edits`}
                            value={privateEdits} 
                            onChange={(e) => setPrivateEdits(e.target.checked) } 
                            label={`Allow the above people to make edits, add and delete`}
                        />
                        <div className="w-100 text-right">
                            <Button onClick={() => shareCollectionWithUsers()}>Share with users</Button>
                        </div>
                        
                    </div>
                )}               
            </Modal>

            <Modal show={showAddPin} onHide={() => setShowAddPin(false)} dialogClassName="add-pin-modal" animation={false} centered>
                {showAddPin && (
                    <div className="add_pin">
                        <h6 className="header">Add Custom Pin</h6>
                        <PinEditor type="add" close={() => setShowAddPin(false)} addedPin={(pinData) => { setMyPins([pinData, ...myPins]); pinData.CollectionId === parseInt(activeCollection) &&  setSelectedCollectionPins([pinData, ...selectedCollectionPins]); }   } />
                    </div>
                )}               
            </Modal>

            <Modal show={showEditPin} onHide={() => setShowEditPin(false)} dialogClassName="add-pin-modal" animation={false} centered>
                {showEditPin && (
                    <div className="add_pin">
                        <h6 className="header">Edit Pin</h6>
                        <PinEditor type="edit" editPin={selectedEditPin} close={() => setShowEditPin(false)} updatePin={(pinData) => updatePin(pinData) } />
                    </div>
                )}               
            </Modal>

            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} animation={false} centered>
                <div className="p-4 text-center">
                    <h3>You are about to delete {selectedPins.length} Pins!</h3>
                    <p style={{ color: "grey"}}>
                        Are you sure you want to do this?
                        <br />
                        <small>This can't be undone!</small>
                    </p>

                    <Button variant="danger" onClick={() => { removePins(); setShowDeleteModal(false) }}>Yes Delete Them!</Button>
                    <Button variant="link" className="text-muted" onClick={() => {setSelectedPins([]); setShowDeleteModal(false) } }>No I made a mistake!</Button>
                    
                </div>
                              
            </Modal>

            <Modal show={showCollectionModal} onHide={() => setShowCollectionModal(false)} animation={false} dialogClassName="copy-pin-modal" centered>
                <div className="p-4 text-left">
                    <h6 className="header">Copy pin to:</h6>
                    {myCollections.map((item, index) =>
                        <p 
                        key={index} 
                        className={item.isSharedCollection && (item.isShared && !item.isEditable) ? "collection-selector not-editable" : "collection-selector"}
                        onClick={() => { if(item.isSharedCollection && (item.isShared && !item.isEditable)){} else {copyPinToCollection(item.Id)} } }
                        >
                            {item.isSharedCollection ?
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip className="white-tool">
                                       {(item.isShared && item.isEditable) ?
                                            <p>
                                                Owned By : <b>{item.OwnedBy}</b>
                                                <br />
                                                Is Editable.                                            
                                            </p>
                                       :
                                            <p>
                                                Owned By : <b>{item.OwnedBy}</b>
                                                <br />
                                                Not Editable.                                            
                                            </p>
                                        }
                                    </Tooltip>
                                }
                                >
                                <i className={(item.isShared && item.isEditable) ? "fas fa-unlock" : "fas fa-lock"}></i>
                            </OverlayTrigger>
                                
                            :
                                <i className={activeCollection === item.Id ? "far fa-folder-open" : "far fa-folder"}></i>
                            }
                            
                            <OverlayTrigger
                                placement="top"
                                overlay={
                                    <Tooltip className="white-tool">
                                            <p>
                                                {item.CollectionName}
                                                <br />
                                                {item.CollectionDescription}                                   
                                            </p>
                                    </Tooltip>
                                }
                                >
                                <span>{item.CollectionName}</span>
                            </OverlayTrigger>                            
                        </p>
                    )}
                </div>
                              
            </Modal>

        </Row>
    );
}